export function generateLabelOrder(order) {
    let labelOrder = {};
    labelOrder.op_order_id = order.orderId;
    labelOrder.carrier = order.order.ship_to_info.ship_to_method;
    labelOrder.po = order.po;
    labelOrder.company_id = order.companyId;

    return labelOrder;
}